jQuery(document).ready(function ($) {

  // eslint-disable-next-line no-undef, no-unused-vars
  var pllLang = pll, ajaxUrl = ajax_object['ajax_url'], ajaxNonce = ajax_object['ajax_nonce'], $active, $content, $links = $('ul.tabs').find('a'), checkBoxes = $('.items_Checkbox');

  /**
   * User Selection logic.
   */
  $('#save_items').click(function () {
    var val = [];
    $(':checkbox:checked').each(function (i) {
      val[i] = $(this).val();
    });

    if (matchMedia('(min-width: 992px)').matches) {
      // Scroll back to top of wizard section.
      $('html, body').animate({
        scrollTop: $('.wizard__results').offset().top - 146,
      }, 100);
    }

    if (matchMedia('(max-width: 991px)').matches) {
      // Scroll back to top of wizard section.
      $('html, body').animate({
        scrollTop: $('.wizard__results').offset().top - 96,
      }, 100);
    }

    console.log(val);

    // Ajax
    jQuery.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: {
        action: 'wizard_result',
        selection: val,
        lang: pllLang,
        nonce: ajaxNonce,
      },
      dataType: 'json',
      beforeSend: function() {

        console.log('Sending Ajax!');

        $('.wizard__empty-state').show();
        $('.selection-notice').hide();
        $('.loading-notice').show();
        $('.wizard__result-items').html('');
      },
      success: function (response) {

        console.log('Received Ajax!');

        if (response['type'] == 'success') {

          $('.loading-notice').hide();
          $('.wizard__empty-state').hide();
          $('.wizard__result-items').html(response['html']);

          // setTimeout(
          //   function()
          //   {
          //     $('.loading-notice').hide();
          //     $('.wizard__empty-state').hide();
          //     $('.wizard__result-items').html(response['html']);
          //   }, 2500);

        } else {
          console.log('Error');
          console.log(response);
        }
      },
    });
  });

  /**
   * Prevent items submission for empty checkboxes.
   */
  checkBoxes.change(function () {
    $('#save_items').prop('disabled', checkBoxes.filter(':checked').length < 1);
  });

  checkBoxes.change();

  $('#wizard__loading').hide();
});



// WEBPACK FOOTER //
// ./scripts/wizard.js